import React from 'react';
import { motion } from 'framer-motion';
import { characters } from '../../data/characters';

interface CharacterSelectorProps {
  selectedCharacter: string | null;
  onSelect: (characterId: string) => void;
}

export const CharacterSelector: React.FC<CharacterSelectorProps> = ({
  selectedCharacter,
  onSelect,
}) => {
  return (
    <div>
      <h3 className="text-2xl font-bold text-gray-900 mb-4">
        Choose Your Character 🎅✨
      </h3>
      <p className="text-gray-600 mb-6">
        Select the character who will deliver your holiday message:
      </p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {characters.map((character) => (
          <motion.button
            key={character.id}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSelect(character.id)}
            className={`relative rounded-xl overflow-hidden aspect-square group ${
              selectedCharacter === character.id
                ? 'ring-4 ring-red-600'
                : 'hover:ring-2 hover:ring-red-300'
            }`}
          >
            <img
              src={character.image}
              alt={character.name}
              className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-white font-medium text-lg">{character.name}</p>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
};